import { makeVar } from '@apollo/client';
import { useReactiveVar } from '@apollo/client/react';

const splitTableCellsPopoverOpenVar = makeVar(false);

export function useSplitTableCellsPopoverOpen(): boolean {
  return useReactiveVar(splitTableCellsPopoverOpenVar);
}

export function openSplitTableCellsPopover(): void {
  splitTableCellsPopoverOpenVar(true);
}

export function closeSplitTableCellsPopover(): void {
  splitTableCellsPopoverOpenVar(false);
}
